import { createSelector } from '@reduxjs/toolkit'

import { getReconcilerState } from './reconcilerSelectors'

const getReconcilerData = createSelector(getReconcilerState, (reconcilerState) => reconcilerState?.data)

export const getReconcilerDataClientsList = createSelector(getReconcilerData, (data) => data?.clientsList)

export const getReconcilerDataClientsListCount = createSelector(getReconcilerData, (data) => data?.clientsListCount)
